exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".keyDiv{text-align:center;cursor:pointer;padding:1rem}.keyImg{width:100%;transition:.5s}.keyNoConnect{width:100vw;height:90vh;display:flex;align-items:center;justify-content:center}.divKeiItem{box-shadow:0 0 10px #ff497a,0 0 20px #511b75;padding:5px;border-radius:.2rem;background-color:rgba(13,14,44,.95)}.divKeiItem:hover>img{transform:scale(.9)}.contentPsdding{padding-bottom:5vh}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3d2fc922","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Keys.vue
// module id = 315
// module chunks = 0